import React, { useCallback, useState } from 'react'
import MasterComponentWraper from '../../Backend/MasterComponentWraper';
import NavigationHeder from '../../Navigations/NavigationHeder';
import ButtonNew from '../../inc/ButtonNew';
import AgGridNew from '../../grid/ag/ag-grid-new';
import ApiMasterFormsPopup from './ApiMasterFormsPopup';
import Api from '../../../inc/Api';
import Settings from '../../../inc/Settings';
import Helper from '../../../inc/Helper';
import { getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import { getLabelFromDropdown, gridLinkValueFormat } from '../../grid/ag/commonFunctions/GridCommonFunctions';
import { useNavigate } from 'react-router-dom';
import DatepickerFunctions from '../../../inc/DatepickerHelper';
import SimpleDropdown from '../../grid/ag/cellEditor/SimpleDropdown';

let gridApi = null;
const ApiMasterFormsListings = () => {
    const [openPopupView, setOpenPopupView] = useState(false);

    const navigate = useNavigate();
  
    const onClickRedirectToDetailView = (event) => {   
        if(event.colDef.field === 'api_name') { 
            navigate(`/edit-api-master-form/${event?.data?.api_id}`)
        }
    }
  
    const onClickPopupView = () => {
        setOpenPopupView(true);
    }
  
    const onDeleteIntegrationDocument = useCallback(async (element) => { 
        let api = Api;
        api.setUserToken();
        
        let delDocument_ID = element?.data?.api_id;
    
        try {
            const res = await api
            .axios()
            .delete(Settings.apiAppUrl+`/api-details/${delDocument_ID}/`)
    
            const rowNode = gridApi?.getRowNode(delDocument_ID)
            
            if (rowNode) {
                rowNode.setSelected(false)
            }
            
            setTimeout(() => {
                const transaction = { remove: [element.data] }
                gridApi?.applyServerSideTransaction(transaction) 
            }, 200);
    
            gridApi?.refreshServerSide({ purge: true })
            gridApi?.deselectAll();
            
            Helper.alert(res?.data?.message || 'Api master deleted successfully', 'success')
        } catch (err) {
            getPopupMessageBasedOnStatus(err)
        }
    }, []);

    const reloadParentGrid = () => {
        gridApi?.refreshServerSide({ purge: true });
        gridApi?.deselectAll();
    };

    const gridColumnHeaders = [
        {field:'api_name', filter: 'agTextColumnFilter', headerName:'API name', editable:false, cellRenderer: (params) => gridLinkValueFormat(params) }, 
        {field:'api_url', headerName:'API URL', editable: false },
        {field:'api_method', headerName:'API method', editable: false },
        {field:'api_key', headerName:'API key', editable: false },
        {field:'api_secret', headerName:'API secret', editable: false },  
        {field:'api_master_id', headerName:'Api master', editable: false },
        {field:'timeout',  headerName:'Timeout', editable: false },
        {field:'retry_count', headerName:'Retry count', editable: false },
        {
            field: 'status',
            headerName: 'Status',
            editable: false, 
            isAllowZero:true,
            cellEditor: SimpleDropdown,
            minWidth:180,  
            cellEditorParams: {
              values: Settings.enumStatus
            },
            cellDataType:false,
            valueFormatter: (params) => getLabelFromDropdown(params)
        },
        {field:'priority', headerName:'Priority', editable: false },
        {field:'type', headerName:'Type', editable: false },
        {field:'created_datetime', valueFormatter: (params) => params.value ? DatepickerFunctions.convertDateTimeFromDataBase(params.value) : null, headerName:'Created date time', editable: false },
        {field:'created_by', headerName:'Created by', editable: false }, 
        {field:'modified_datetime', headerName:'Modified date time', valueFormatter: (params) => params.value ? DatepickerFunctions.convertDateTimeFromDataBase(params.value) : null, editable: false },
        {field:'modified_by', headerName:'Modified by', editable: false }, 
    ];

    return (
        <div className='container-fluid'>
            <NavigationHeder hideMoreBtn={true} backUrl='/system-integration' title={'API Master'}>
                <ButtonNew onClick={onClickPopupView} title={'New'}  />
            </NavigationHeder>
                
            <AgGridNew
                apiUrl={Settings.apiAppUrl+'/api-details/'} 
                pagination={false}
                columnDefs={gridColumnHeaders} 
                hideAddBtn={true}
                height={500}
                uniqueField={'api_master_id'}
                onCellClicked={onClickRedirectToDetailView}
                handleDeleteSelectedRows={onDeleteIntegrationDocument}
                onGridReady={(params) => gridApi = params?.api} 
                gridId={"api_master_forms_listing_grid"}
            />

            {openPopupView && <ApiMasterFormsPopup reloadParentGrid={reloadParentGrid} setClosePopupViewModal={setOpenPopupView} />}
        </div> 
    )
}

export default (MasterComponentWraper(ApiMasterFormsListings));